<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label">
            <b class="title-header">フォーム詳細・編集</b>
          </h3>
        </div>
      </div>
      <div class="card-body">
        <el-form
          ref="ruleForm"
          label-position="left"
          label-width="40%"
          class="demo-ruleForm form-base"
          v-if="formBase.formBase"
        >
          <div class="row mb-8">
            <div class="col-12 col-md-10 col-xl-5">
                <label class="el-form-item__label " for="">フォーム名
                    <span class="text-danger">*</span>
                </label>
              <el-form-item
                label=""
                class="custom_reponsive"
                prop="form_name"
              >
                <el-input
                  @keypress.enter.native.prevent="confirmEdit"
                  maxlength="40"
                  v-model="formBase.formBase.form_name"
                  class="bg-gray-item"
                  placeholder="フォーム名を入力"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-10 col-xl-5">
                <label class="el-form-item__label " for="">フォームURL
                    <span class="text-danger">*</span>
                </label>
              <el-form-item
                class="custom_reponsive"
                label=" "
                prop="form_url"
              >
                <el-input
                  @keypress.enter.native.prevent="confirmEdit"
                  maxlength="300"
                  v-model="formBase.formBase.form_url"
                  class="bg-gray-item"
                  placeholder="フォームURLを入力"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-10 col-xl-5">
                <label class="el-form-item__label " for="">項目グループ名
                    <span class="text-danger">*</span>
                </label>
              <el-form-item
                label=""
                prop="item_group_names"
                class="custom_reponsive"
              >
                <el-input
                  maxlength="1000"
                  class="bg-gray-item"
                  v-model="item_group_names"
                  type="textarea"
                  placeholder="項目グループ名を入力"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-10 col-xl-5">
                <label class="el-form-item__label " for="">項目グループ名（中）</label>
              <el-form-item label="" prop="item_group_name_middle" class="custom_reponsive">
                <el-input class="bg-gray-item" v-model="item_group_name_middle" type="textarea" placeholder="項目グループ名（中）を入力"></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-10 col-xl-5">
                <label class="el-form-item__label " for="">ステータス
                    <span class="text-danger">*</span>
                </label>
              <el-form-item
                label=""
                prop="form_status"
                class="custom_reponsive"
              >
                <el-select
                placeholder="ステータス"
                v-model="formBase.formBase.form_status"
                type="text"
                style="width:100%;height: 10%"
              >
                <el-option v-for="status in formStatus" :value="status.value" :label="status.label" :key="status.value">{{ status.label }}</el-option>
              </el-select>
              </el-form-item>
            </div>
          </div>
          <!-- part 2 -->
<!--          phase 2-->
          <div class="row mb-8">
            <div class="col-md-10 col-xl-5">
              <el-form-item label="親フォーム名" prop="parent_form_id" class="custom_reponsive">
                <el-select placeholder="選択してください" v-model="formBase.formBase.parent_form_id" style="width:100%;height: 10%">
                  <el-option label="なし" :value="null"></el-option>
                <el-option v-for="form in formBase.listForm"
                           :value="form.form_id" :label="form.form_name" :key="form.form_id">
                    {{ form.form_name }}
                </el-option>
              </el-select>
              </el-form-item>
            </div>
          </div>
            <div v-if="currentUser.super_user" class="row mb-8">
                <div class="col-12 col-md-10 col-xl-5">
                    <label class="el-form-item__label" for=""> テナント</label>
                    <el-form-item class="item-title-form item-fome-base" label=""
                                  prop="tenant_code">
                        <el-select @change="changeTenant(true)" class="w-100"  v-model="formBase.formBase.tenant_code" placeholder="選択してください">
                            <el-option label="なし" value=" "></el-option>
                            <el-option
                                v-for="(item, index) in listTenant.filter(item => item !== null)"
                                :key="index"
                                :label="item.tenant_name"
                                :value="item.tenant_code">
                            </el-option>
                            <el-option
                                v-if="listTenant && listTenant.includes(null)"
                                label="テナント無し"
                                :value="null">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
          <div class="row mb-8">
            <div class="col-md-10 col-xl-5">
              <el-form-item label="適用承認プロセス名" prop="approval_name" class="custom_reponsive">
                <el-select @change="changeApproval()" placeholder="選択してください" v-model="approval_id" type="text" style="width:100%;height: 10%">
                    <el-option label="なし" value=" "></el-option>
                    <el-option v-for="approval in list_approval"
                               :value="approval.approval_id" :label="approval.approval_name" :key="approval.approval_id">
                        {{ approval.approval_name }}
                    </el-option>
              </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8" v-if="formBase.formBase.kaiso_flg && formBase.formBase.approval_id ">
              <div class="col-md-10 col-xl-5">
                  <el-form-item class="breadcrumb-wrapper" label="階層状況">
                          <ol class="breadcrumb" v-if="formBase.formBase.tenant_breadcrumb && formBase.formBase.tenant_breadcrumb.length > 0">
                              <li 
                                  v-for="(item, index) in formBase.formBase.tenant_breadcrumb" 
                                  :key="index"
                                  class="breadcrumb-item"
                              >
                                  <span 
                                      v-if="item"
                                      class="breadcrumb-link cursor-pointer" 
                                      @click.prevent="handleBreadcrumbClick(item)"
                                  >
                                      {{ item.tenant_name }}
                                  </span>
                                  <span v-else>
                                      テナント無し
                                  </span>
                              </li>
                          </ol>
                          <p v-else>テナント無し</p>
                  </el-form-item>
              </div>
          </div>
          <div class="row mb-8">
              <div class="col-md-10 col-xl-5">
                  <label class="el-form-item__label"></label>
                  <el-form-item class="item-title-form item-fome-base " label="">
                      <el-checkbox v-model="formBase.formBase.display_new_account">新規入力許可</el-checkbox>
                  </el-form-item>
              </div>
          </div>
          <div class="row mb-8">
              <div class="col-md-10 col-xl-5">
                  <label class="el-form-item__label"></label>
                  <el-form-item class="item-title-form item-fome-base " label="">
                      <el-checkbox v-model="formBase.formBase.allow_login_form">ログイン遷移許可</el-checkbox>
                  </el-form-item>
              </div>
          </div><div class="row mb-8">
              <div class="col-md-10 col-xl-5">
                  <label class="el-form-item__label"></label>
                  <el-form-item class="item-title-form item-fome-base " label="">
                      <el-checkbox v-model="formBase.formBase.allow_mypage_access">マイページ遷移許可 </el-checkbox>
                  </el-form-item>
              </div>
          </div>

            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <div class="henshu-form-base">
                        <el-form-item class="item-title-form item-fome-base henshu-form-child" label="" prop="copy_flag">
                            <el-checkbox :disabled="!formBase.formBase.parent_form_id"
                                         v-model="formBase.formBase.copy_flag">回答時に回答項目を親フォームからコピー
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item class="item-title-form item-fome-base " label="" prop="henshu_flg">
                            <el-checkbox v-model="formBase.formBase.henshu_flg">申請者が入力完了後にも情報修正を可能</el-checkbox>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <el-form-item class="item-title-form item-fome-base" label="">
                        <el-checkbox v-model="formBase.formBase.copy_group_name" :disabled="formBase.formBase.special_item">回答時に項目グループ単位での解答欄複製を許可する</el-checkbox>
                    </el-form-item>
                </div>
            </div>
            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <el-form-item class="item-title-form item-fome-base" label="">
                        <el-checkbox v-model="formBase.formBase.copy_group_name_middle" :disabled="formBase.formBase.special_item">回答時に項目グループ（中）単位での解答欄複製を許可する</el-checkbox>
                    </el-form-item>
                  
                    <el-form-item class="item-title-form items_group_name_middle_manual " label="" prop="item_group_name_middle_selected">
                      <el-select 
                      placeholder="選択してください" 
                      :disabled="formBase.formBase.special_item || !formBase.formBase.copy_group_name_middle"
                      multiple 
                      v-model="items_group_name_middle_selected" 
                      type="text"
                      class="items_group_name_middle_manual"
                      
                      @change="changeCheckItemsGroupMiddleManual(items_group_name_middle_selected)"
                      >
                        <el-option label="なし" value=" "></el-option>
                        <el-option v-for="(item,index) in getItemsGroupMiddle()" :value="item" :label="item" :key="index">
                            {{ item }}
                        </el-option>
                      </el-select>
                    </el-form-item>
                </div>
            </div>

            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <el-form-item class="item-title-form item-fome-base " label="">
                        <el-checkbox :disabled="!formBase.formBase.parent_form_id || formBase.formBase.form_status != 1" v-model="formBase.formBase.mail_flag">親フォームの回答者に「子フォーム回答依頼メール」を発出</el-checkbox>
                    </el-form-item>
                </div>
            </div>
            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <el-form-item class="item-title-form item-fome-base " label="" prop="kaiso_flg">
                        <el-checkbox :disabled="disabled_check || isKaisoFlgDisabled" v-model="formBase.formBase.kaiso_flg"> 階層フォームとする</el-checkbox>
                    </el-form-item>
                </div>
            </div>
            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <el-form-item class="item-title-form item-fome-base " label="" prop="send_child_tenant_login_mail">
                        <el-checkbox :disabled="!formBase.formBase.kaiso_flg || !hasSelectedApprovalId(approval_id) || isApprovalKaisoZero" v-model="formBase.formBase.send_child_tenant_login_mail"> 承認時、回答者にログインURL、ログインIDをメールで通知する</el-checkbox>
                    </el-form-item>
                </div>
            </div>
            <div class="row mb-8">
                <div class="col-md-10 col-xl-5">
                    <label class="el-form-item__label"></label>
                    <el-form-item class="item-title-form item-fome-base " label="" prop="tenant_copy_flg">
                        <el-checkbox :disabled="disabled_check" v-model="formBase.formBase.tenant_copy_flg">子テナントにコピーする</el-checkbox>
                    </el-form-item>
                </div>
            </div>
          <div class="row mb-8">
              <div class="col-md-10 col-xl-5">
                  <label class="el-form-item__label"></label>
                  <el-form-item class="item-title-form item-fome-base " label="" prop="special_item">
                      <el-checkbox :disabled="formBase.formBase.display_special_item || formBase.formBase.copy_group_name || formBase.formBase.copy_group_name_middle || formBase.formBase.check_copy_item" v-model="formBase.formBase.special_item">条件分岐・自動計算の機能</el-checkbox>
                  </el-form-item>
              </div>
          </div>
          <div class="row mb-8">
              <div class="col-md-10 col-xl-5">
                  <label class="el-form-item__label"></label>
                  <el-form-item class="item-title-form item-fome-base " label="" prop="same_tenant_validation_flg">
                      <el-checkbox  v-model="formBase.formBase.same_tenant_validation_flg">
                        <span>同一テナント内の他フォーム間Validationを有効とする（且つ、親子テナントも含む）</span> <br/>
                        <span>（チェックが無い場合は、親子フォーム、親子テナントのみ）</span>
                      </el-checkbox>
                  </el-form-item>
              </div>
          </div>

<!--          phase 2-->
          <!-- end part 2 -->
          <el-form-item prop="action" class="button-search" label-width="0px">
              <el-row>
                  <el-button
                      type="primary"
                      @click.prevent="confirmEdit"
                  >入力完了</el-button>
                  <button
                      type="button"
                      @click="confirmDelete()" class="btn btn-danger ml-5">
                      削除
                  </button>
              </el-row>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <Popup id="confirm" title="確認" :content="title" :title_button="no_confirm">
        <b-button @click.prevent="editForm()" class="btn-primary">{{ $t("YES") }}</b-button>
    </Popup>
    <Popup id="error-edit" :content="title" :title_button="close_popup">
    </Popup>
      <Popup id="confirm-delete" :content="content_delete_form" title_button="いいえ">
          <b-button @click.prevent="deleteFormBase" class="btn-primary">{{ $t("YES") }}</b-button>
      </Popup>
      <my-dialog v-on:closeDialog="not_permisson_popup=false" v-on:submit="not_permisson_popup=false;$router.push({name: 'permission-denied'});" v-bind:dialog="not_permisson_popup"
                 :closeOnClickModal="false" width="28%" v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')" :showCancelButton="false">
          <template slot="header">
              <div class="textwidget text-center">
                  {{ $t('DIALOG.TITLE_PERMISSON_DENIED') }}
              </div>
          </template>
      </my-dialog>
      
      <!-- Modal for access_options error -->
      <my-dialog v-on:closeDialog="accessOptionsError=false" v-on:submit="accessOptionsError=false" v-bind:dialog="accessOptionsError"
         :closeOnClickModal="false" width="28%" btnOk="閉じる" :showCancelButton="false">
          <template slot="content">
              <div class="textwidget text-center">
                <p>「新規入力許可、ログイン遷移許可、マイページ遷移許可」</p> 
                {{ accessOptionsMessage }}
              </div>
          </template>
      </my-dialog>
      
      <!-- Modal for breadcrumb permission error -->
      <my-dialog v-on:closeDialog="breadcrumbPermissionError=false" v-on:submit="breadcrumbPermissionError=false" v-bind:dialog="breadcrumbPermissionError"
         :closeOnClickModal="false" width="28%" btnOk="閉じる" :showCancelButton="false">
          <template slot="content">
              <div class="textwidget text-center">
                アカウントの権限がありませんですので、管理者にご連絡してください。
              </div>
          </template>
      </my-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { GET_FORM_BASE,HANDLE_EDIT_FORM,DELETE_FORM_BASE_BY_ID} from "@/core/services/store/formBase.module";
import * as constants from "@/core/config/constant";
import Popup from "@/view/components/Popup";
import {GET_ALL_TENANT} from "@/core/services/store/mtenant.module";
import CheckboxMulti from "@/view/components/inputs/CheckboxMulti";

export default {
  name: "edit",
  components: {
    Popup,
    CheckboxMulti
  },
  data() {
    return {
      loading: false,
      item_group_names: '',
      item_group_name_middle: '',
      constants: constants,
      formStatus: constants.FORM_BASE_STATUS,
      title: '',
      no_confirm: this.$t("NO"),
      close_popup: this.$t("close_popup_error"),
      approval_id: '',
      content_delete_form: '',
      not_permisson_popup:false,
      disabled_check: false,
      listTenant: [],
      list_approval: [],
      items_group_name_middle_selected: [],
      accessOptionsError: false,
      accessOptionsMessage: '',
      breadcrumbPermissionError: false
    };
  },
  computed: {
    ...mapGetters(["formBase","currentUser"]),
    queryParam() {
      return this.$route.params;
    },
    isApprovalKaisoZero() {
      if (!this.hasSelectedApprovalId(this.approval_id)) {
        return false;
      }
      const selectedApproval = this.list_approval.find(
        (approval) => approval.approval_id == this.approval_id
      );
      return selectedApproval && selectedApproval.approval_kaiso === 0;
    },
    isKaisoFlgDisabled() {
      return !this.hasSelectedApprovalId(this.approval_id);
    }
  },
  async created() {
    this.loading = true;
      if (this.hasPermissonCheck('form_flg')){
          await this.getFormBase(this.queryParam.form_id);
          this.approval_id = this.formBase.formBase.approval? this.formBase.formBase.approval.approval_id : '';
          if( this.formBase.formBase.item_group_name_middle === null ){
            this.items_group_name_middle =  []
          } else  if( this.formBase.formBase.item_group_name_middle.includes('{') ){
            this.items_group_name_middle =  Object.values(JSON.parse(this.formBase.formBase.item_group_name_middle))
          } else {
            this.items_group_name_middle = this.formBase.formBase.item_group_name_middle.split(",").map(function(value){
                  return value.trim()
              }).filter(function(value){ 
                  return value.length > 0 
              })
          }
          this.items_group_name_middle = this.items_group_name_middle.map(function(value){
                                        return value.trim()
                                    }).filter(function(value){ 
                                        return value.length > 0 
                                    })

          if( this.formBase.formBase.item_group_name_middle_selected === null ){
            this.items_group_name_middle_selected = []
          } else  if( this.formBase.formBase.item_group_name_middle_selected.includes('{') ){
            this.items_group_name_middle_selected =  Object.values(JSON.parse(this.formBase.formBase.item_group_name_middle_selected))
          } 

          this.items_group_name_middle_selected = this.items_group_name_middle_selected.map(function(value){
                                        return value.trim()
                                    }).filter(function(value){ 
                                        return value.length > 0 
                                    })
          
          // this.list_approval = this.formBase.listApproval;
          this.convertItemGroupName();
          if (this.currentUser.super_user){
              const tenants = await this.getAllTenant();
              this.listTenant = tenants ? tenants.filter(item => item !== null) : [];
          }
          this.changeTenant();
      }else {
          this.not_permisson_popup = true
      }
      this.changeApproval();
    this.$nextTick(() => {
      if(this.formBase && this.formBase.formBase) {
        if(this.formBase.formBase.parent_form_id == null || this.formBase.formBase.parent_form_id == '') {
          this.formBase.formBase.copy_flag = false
          this.formBase.formBase.mail_flag = false
        }
        // Khởi tạo send_child_tenant_login_mail nếu chưa có
        if (this.formBase.formBase.send_child_tenant_login_mail === undefined || this.formBase.formBase.send_child_tenant_login_mail === null) {
          this.formBase.formBase.send_child_tenant_login_mail = false;
        }
      }
    });
    this.loading = false;

  },
  watch: {
    'formBase.formBase.parent_form_id'(newValue) {
      if (!newValue || !String(newValue).trim()){
        if (this.formBase && this.formBase.formBase) {
          this.formBase.formBase.copy_flag = false;
        }
      }
    },
    'formBase.formBase.kaiso_flg'(newValue) {
      if (this.formBase && this.formBase.formBase) {
        if (!newValue || !this.hasSelectedApprovalId(this.approval_id)) {
          this.formBase.formBase.send_child_tenant_login_mail = false;
        }
      }
    },
    approval_id(newValue) {
      if (this.formBase && this.formBase.formBase) {
        if (!this.hasSelectedApprovalId(newValue)) {
          this.formBase.formBase.kaiso_flg = false;
          this.formBase.formBase.send_child_tenant_login_mail = false;
        } else if (!this.formBase.formBase.kaiso_flg) {
          this.formBase.formBase.send_child_tenant_login_mail = false;
        }
      }
    },
    isApprovalKaisoZero(newValue) {
      if (this.formBase && this.formBase.formBase) {
        if (newValue) {
          this.formBase.formBase.send_child_tenant_login_mail = false;
        }
      }
    }
  },
  methods: {
    ...mapActions([GET_FORM_BASE,HANDLE_EDIT_FORM,DELETE_FORM_BASE_BY_ID,GET_ALL_TENANT]),
    hasSelectedApprovalId(approvalId) {
      if (approvalId === null || approvalId === undefined) {
        return false;
      }
      return String(approvalId).trim() !== '';
    },
    convertItemGroupName(){
        var obj =JSON.parse(this.formBase.formBase.item_group_names);
          var arr = []
              Object.keys(obj).forEach(function(key){
                arr.push(obj[key].trim())
            })
            this.item_group_names = arr.join(', ');
        if (this.formBase.formBase.item_group_name_middle){
            var objMiddle =JSON.parse(this.formBase.formBase.item_group_name_middle);
            var arrMiddle = []
            Object.keys(objMiddle).forEach(function(key){
                arrMiddle.push(objMiddle[key].trim())
            })
            this.item_group_name_middle = arrMiddle.join(', ');
        }
    },
    editForm(){
      this.turnOffErrorMessage("ruleForm");
      this.item_group_name_middle_error = ''
      const {items_group_name_middle,items_group_name_middle_selected } = this;
      const item_group_name_middle_selected = this.formBase.formBase
      console.log(`==== handler submit`, {items_group_name_middle,items_group_name_middle_selected, item_group_name_middle_selected} )
      // return;
      this.handleEditForm(
        {
          form_id: this.formBase.formBase.form_id,
          form_name: this.formBase.formBase.form_name,
          form_url: this.formBase.formBase.form_url,
          item_group_names: this.item_group_names,
          item_group_name_middle: this.item_group_name_middle,
          form_status: this.formBase.formBase.form_status,
          parent_form_id: this.formBase.formBase.parent_form_id,
          approval_id: this.approval_id,
          copy_flag: this.formBase.formBase.copy_flag,
          henshu_flg: this.formBase.formBase.henshu_flg,
          mail_flag: this.formBase.formBase.mail_flag,
          copy_group_name: this.formBase.formBase.copy_group_name,
          copy_group_name_middle: this.formBase.formBase.copy_group_name_middle,
          kaiso_flg: this.formBase.formBase.kaiso_flg,
          tenant_copy_flg: this.formBase.formBase.tenant_copy_flg,
          tenant_code: this.formBase.formBase.tenant_code,
          display_new_account: this.formBase.formBase.display_new_account,
          allow_login_form: this.formBase.formBase.allow_login_form,
          allow_mypage_access: this.formBase.formBase.allow_mypage_access,
          special_item: this.formBase.formBase.special_item,
          item_group_name_middle_selected : items_group_name_middle_selected,
          same_tenant_validation_flg: this.formBase.formBase.same_tenant_validation_flg,
          send_child_tenant_login_mail: this.formBase.formBase.send_child_tenant_login_mail,
        }
      ).then((response)=>{
        if(response.data.code==constants.STATUS_CODE.SUCCESS){
           this.notifySuccess(this.$t("UPDATE_SUCCESS"));
            this.$bvModal.hide("confirm");
            let self = this;
            setTimeout(function () {
              self.$router.push({
                name: "form-base-list",
              });
            }, 500);
        }else {
          if(response.data.code == constants.STATUS_CODE.HTTP_BAD_REQUEST){
            this.notifyError(response.data.message);
          }
          else{
            if (response.data.data && response.data.data.access_options && response.data.data.access_options.length > 0) {
              this.accessOptionsMessage = response.data.data.access_options[0];
              this.accessOptionsError = true;
            }
            this.showErrorMessage(response.data.data, "ruleForm");
            if( typeof response.data.data.item_group_name_middle_selected !== 'undefined'){
              this.item_group_name_middle_error = response.data.data.item_group_name_middle_selected
            }
          }
          this.$bvModal.hide("confirm");
        }
      }).catch(e=>{
        this.title = e.response.data.message;
        this.$bvModal.show("error-edit");
        this.$bvModal.hide("confirm");
      })
    },
    confirmEdit(){
      this.title = this.$t("CONFIRM_EDIT" , {form_name: this.formBase.formBase.form_name})
      this.$bvModal.show("confirm");
    },
      confirmDelete(){
          this.content_delete_form = this.$t("CONFIRM_DELETE" , {form_name: this.formBase.formBase.form_name});
          this.$bvModal.show("confirm-delete");
      },
      async deleteFormBase(){
          this.loading = true;
          let data = await this.deleteFormBaseById(this.formBase.formBase.form_id);
          if (data){
              this.notifySuccess(this.$t("DELETE_SUCCESS"));
              this.$bvModal.hide("confirm-delete");
              this.$router.push({name: "form-base-list"});
          }
          this.loading = false;
      },
      changeApproval(){
          const findCurrentApproval = this.list_approval.find(
              (data) => data.approval_id == this.approval_id
          );
          if (findCurrentApproval && findCurrentApproval.approval_kaiso === 0){
            if (this.formBase && this.formBase.formBase) {
              this.formBase.formBase.send_child_tenant_login_mail = false;
            }
          }
      },
      changeTenant(isCreate = false){
        if (isCreate) {
            this.approval_id = '';
        }
          this.list_approval = this.formBase.listApproval.filter(data => {
              if (data.tenant_code === this.formBase.formBase.tenant_code){
                  return true;
              }
              else if((this.formBase.formBase.tenant_code === ' ' || !this.formBase.formBase.tenant_code) && !data.tenant_code){
                  return true;
              }
              return false;
          });
          const currentApproval = this.list_approval.find(
              (data) => data.approval_id == this.approval_id
          );
          if (!currentApproval){
              this.approval_id = '';
          }
      },
    getItemsGroupMiddle(){
      const options = this.item_group_name_middle.split(",").map(function(value){
        return value.trim()
      }).filter(function(value){ 
        return value.length > 0 
      })
      return options
    },
    changeCheckItemsGroupMiddleManual(values){
      values.map( (value, keys) => {
          if (value==' '){
              this.items_group_name_middle_selected=[]
          }
      });
    },
    
    // Check if user can access tenant
    canAccessTenant(item) {
      if (!this.currentUser.role || !item) {
        return false;
      }
      // Check if tenant_code matches
      const isSameTenant = item.tenant_code === this.currentUser.role.tenant_code;
      
      return isSameTenant;
    },
    
    // Handle breadcrumb click
    handleBreadcrumbClick(item) {
      if (!item) return;
      if(this.currentUser.role && this.currentUser.role.tenant_code === null){
        window.open(item.admin_url, '_blank')
        return;
      }
      if(item.tenant_status === 2){
        // Redirect to 404 page
        this.$router.push({ name: '404' })
        return;
      }
      // Check if user can access
      if ((this.canAccessTenant(item) && this.currentUser.role.kengen_flg === 1) || (this.canAccessTenant(item) && this.currentUser.role.tennant_flg === 1) || (this.currentUser.role.kengen_flg === 1 && this.currentUser.role.tennant_flg === 1 && this.canAccessTenant(item))) {
        // Redirect to admin login page
        window.open(item.admin_url, '_blank')
      } else {
        // Show permission error popup
        this.breadcrumbPermissionError = true;
      }
    }
  },
};
</script>

<style lang="scss">
.items_group_name_middle_manual {
  width: 100%;
}
.items_group_name_middle_manual .el-form-item__content,
.items_group_name_middle_manual .el-form-item__error {
  padding-left: 15px;
}

// Breadcrumb styles
.breadcrumb-wrapper {
  .el-form-item__content {
    line-height: normal;
  }
  
  .breadcrumb {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
    list-style: none;
    background-color: transparent;
    border-radius: 6px;
  }
  
  .breadcrumb-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #7e8299;
    
    + .breadcrumb-item {
      padding-left: 8px;
      
      &::before {
        display: inline-block;
        padding: 0 8px;
        content: ">";
        color: #b5b5c3;
        font-weight: 600;
      }
    }
    
    &.active {
      color: #181c32;
      font-weight: 500;
    }
  }
  
  .breadcrumb-link {
    color: #009ef7;
    transition: color 0.2s ease;
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
      text-decoration-thickness: 2px; 
    }
  }
}

@media only screen and (max-width: 992px) {
    .items_group_name_middle_manual .el-form-item__content {
        margin-left: 0 !important;
  }
  
  .breadcrumb-wrapper {
    .breadcrumb {
      padding: 8px 12px;
    }
    
    .breadcrumb-item {
      font-size: 13px;
    }
  }
}
</style>
